import { render, staticRenderFns } from "./CardFolder.vue?vue&type=template&id=0f1b8f5b&scoped=true"
import script from "./CardFolder.vue?vue&type=script&lang=js"
export * from "./CardFolder.vue?vue&type=script&lang=js"
import style0 from "./CardFolder.vue?vue&type=style&index=0&id=0f1b8f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b8f5b",
  null
  
)

export default component.exports